import React from "react";
import rootDir from "../..";
import { Link } from "react-router-dom";

import { useHeader } from "../../lib/varHeader";
import { useFilter } from "../../lib/varFilter";

interface Props {
    sorter: string;
    // reverse: boolean | undefined;
}

const Sorter = ({sorter}: Props) => {
    const { setHeader } = useHeader();
    const { setFilter } = useFilter();
    const { filter } = useFilter();

    let asc = '';
    let color = 'yellow';
    let sortTopic = 'X'
    let sortOrder = ''

    switch (sorter) {
        case 'id':
            sortTopic = 'ID'
            sortOrder = ' newest'
            if (filter.sort_by === sorter) {
                color = 'magenta'
                asc = 'desc/'
            }
            break;
        case 'artist':
            sortTopic = 'Artist'
            sortOrder = ' A-Z'
            if (filter.sort_by === sorter) {
                color = 'green'
                asc = 'asc/'
            }
            break
        case 'album':
            sortTopic = 'Album'
            sortOrder = ' A-Z'
            if (filter.sort_by === sorter) {
                color = 'green'
                asc = 'asc/'
            }
            break
        case 'song':
            sortTopic = 'Song Title'
            if (filter.sort_by === sorter) {
                color = 'green'
                asc = 'asc/'
                sortOrder = ' A-Z'
            }
            break
        case 'duration':
            sortTopic = 'Song Duration'
            sortOrder = ' shortest'
            if (filter.sort_by === sorter) {
                color = 'green'
                asc = 'asc/'
            }
            break
        case 'new_arr':
            sortTopic = "Arrangements"
            sortOrder = ' newest'
            if (filter.sort_by === sorter) {
                color = 'blue'
                asc = 'desc/'
            }
            break
        case 'plays':
            sortTopic = "Total Plays"
            sortOrder = ' most played'
            if (filter.sort_by === sorter) {
                color = 'green'
                asc = 'desc/'
            }
            break
        default:
            break;
    }

    function set_sort_order() {
        const newFilter = {
            sort_by: sorter,
        }
        const newHeader = {
            current_loaded_page: 0,
        }
        setFilter((prev) => ({ ...prev, ...newFilter}))
        setHeader((prev) => ({ ...prev, ...newHeader}))
        // console.log('filter => ', filter)
    }
    return (
        <Link to={rootDir+'page/1'}>
            <button className="sorter" onClick={() => set_sort_order()}>
                <img src={rootDir+"img/sort/"+asc+color+".png"} height={16} alt="Sort" title={"Sort on "+sortTopic+sortOrder}/>
            </button>
        </Link>
    )
}

export default Sorter